import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import workSpaceCss from "../../css/workSpaceOverView.module.css";
import FSSideMenu from "../../components/consol/FSSideMenu";
import FSTopBar from "../../components/consol/FSTopBar";

import swal from "sweetalert";
import {
  deletePopulateFSApiHandler,
  getConsolPrePopulateFSDetailsApiHandler,
  updatePopulateFSApiHandler,
} from "../../../WorkSpace/Components/ApiServices/apiHandler";
import { motion } from "framer-motion";
import commoncss from "../../css/common.module.css";
import bookclosurecss from "../../css/bookclosure.module.css";
import QuillReactEditor from "../../components/QuillReactEditor";
import ConsolFSTable from "./ConsolFSTable";
import ConsolFSBottomAddSection from "./ConsolFSBottomAddSection";
import InterCompanyEliminationsEntries from "../../components/console/InterCompanyEliminationEntires";
import BSPLTable from "../../../Console/Component/CustomTable/BSPLTable";
import ConsoleTable from "../../../Console/Component/CustomTable/ConsoleTable";
import ICEWorkings from "../../components/console/ICEWorkings";
import PerformReconciliation from "../../components/console/PerformReconciliation";
import ViewReconciliation from "../../components/console/ViewReconciliation";
import AdjAutoPopulatedEntries from "../../components/console/AdjAutoPopulatedEntries";
import ManualAdjustments from "../../components/console/ManualAdjustments";
import sidemenucss from "../../css/sidemenu.module.css";
import { useLocation } from "react-router-dom";

const FS_CATS_WITHOUT_ROW_AND_BOTTOM_UI = [
  "BS",
  "PL",
  "BS notes",
  "PL notes",
  "Adjustments",
  "socie",
];

const ConsolPrePopulateFS = () => {
  const { consolID } = useParams();

  const history = useHistory();
  const dispatch = useDispatch();

  const [activeCat, setActiveCat] = useState(() => {
    let isReload = false;
    try {
      const navigationEntries = performance.getEntriesByType("navigation");
      if (navigationEntries.length > 0) {
        isReload = navigationEntries[0].type === "reload";
      } else if (window.performance && window.performance.navigation) {
        isReload = window.performance.navigation.type === 1;
      }
    } catch (e) {
      console.warn("Performance API navigation type check failed:", e);
    }

    if (isReload) {
      return sessionStorage.getItem(`consol_active_cat_${consolID}`) || "BS";
    }
    return "BS";
  });
  const [isNotes, setIsNotes] = useState(false);
  const [loadData, setLoadData] = useState([]);
  const [notesId, setNotesId] = useState(null);
  const [redirectNote, setRedirectNote] = useState(null);
  const [subMenuId, setSubMenuId] = useState(null);
  const [subgroupId, setSubGroupId] = useState(null);
  const [columns, setColumns] = useState([]);
  const [subMenu, setSubMenu] = useState(null);
  const [bsPlData, setBsPlData] = useState(null);
  const [consoleData, setConsoleData] = useState(null);
  const [rows, setRows] = useState([]);
  const [notesData, setNotesData] = useState(null);
  const [updateTrigger, setUpdateTrigger] = useState(0);
  const [adjSubMenu, setAdjSubMenu] = useState("Auto populated entries");
  const [socieData, setSocieData] = useState(null);
  const [eliminationScreen, setEliminationScreen] = useState(0);
  const [selectedConsolName, setSelectedConsolName] = useState("");
  const workspace_data = useSelector((state) => state.WSReducer);
  const workspaceName = workspace_data?.response?.[0]?.workspace_name || sessionStorage.getItem("adj_workspace_name") || localStorage.getItem("workspaceName") || "Workspace";
  const workspaceID = workspace_data?.response?.[0]?._id || localStorage.getItem("ws_id") || "";
  const consolName = selectedConsolName || sessionStorage.getItem("adj_consol_name") || "Consol";

  useEffect(() => {
    if (workspace_data?.response?.[0]?.workspace_name) {
      sessionStorage.setItem("adj_workspace_name", workspace_data.response[0].workspace_name);
    }
  }, [workspace_data]);
  const [selectedReconciliationRow, setSelectedReconciliationRow] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [redirectSearch, setRedirectSearch] = useState(null);
  const [targetSubGroupId, setTargetSubGroupId] = useState(null);
  const categoryRef = useRef(activeCat);
  const location = useLocation();

  const [bottomBlocks, setBottomBlocks] = useState([]);
  const [isAddingTable, setIsAddingTable] = useState(false);
  const [forceOpenTableId, setForceOpenTableId] = useState(null);

  const genId = () => Math.random().toString(36).slice(2);

  const allowTableRowAdd =
    !FS_CATS_WITHOUT_ROW_AND_BOTTOM_UI.includes(activeCat) &&
    activeCat !== "checklist";
  const showBottomAddControls = allowTableRowAdd;

  const handleAddParagraph = () => {
    setBottomBlocks((prev) => [
      ...prev,
      { id: genId(), type: "text", text: [{ content: "" }] },
    ]);
  };

  const handleAddTable = () => {
    setIsAddingTable(true);
  };

  const removeItem = (id) => {
    setBottomBlocks((prev) => prev.filter((b) => b.id !== id));
  };

  const updateEditorContent = (id, newContent) => {
    setBottomBlocks((prev) =>
      prev.map((b) =>
        b.id === id ? { ...b, text: [{ content: newContent }] } : b
      )
    );
  };

  const updateTableItem = (id, patch) => {
    setBottomBlocks((prev) =>
      prev.map((b) => (b.id === id ? { ...b, ...patch } : b))
    );
  };

  const onNewTableBlock = (next) => {
    const id = genId();
    setBottomBlocks((prev) => [
      ...prev,
      {
        id,
        type: "table",
        tableTitle: next.tableTitle,
        tableRow: next.tableRow,
        tableColumn: next.tableColumn,
        hasCellData: next.hasCellData,
        tableData: next.tableData,
        tableType: "",
        table: [],
      },
    ]);
  };

  const onDragEndItems = (result) => {
    if (!result.destination) return;
    const items = Array.from(bottomBlocks);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    setBottomBlocks(items);
  };

  const formatIndianNumber = (val) => {
  if (val == null) return "";
  const num = Number(val);
  if (isNaN(num)) return String(val);

  if (num < 0) {
    return "(" + (-1 * num).toLocaleString("en-IN") + ")";
  }
  return num.toLocaleString("en-IN");
};
  const eliminationScreens = {
    0: "entries",
    1: "workings",
    2: "performreconciliation",
    3: "viewreconciliation",
  }

  useEffect(() => {
    if (location.state?.consolName) {
      setSelectedConsolName(location.state.consolName);
      sessionStorage.setItem("adj_consol_name", location.state.consolName);
    }
  }, [location.state?.consolName]);

  useEffect(() => {
    if ((activeCat === "BS") || (activeCat === "PL")) {
      const result = transformData(loadData ?? []);
      setRows(result ?? []);
    } else {

      setRows(loadData ?? []);
    }
  }, [loadData]);


  useEffect(() => {
    setColumns([]);

    if (activeCat !== "Adjustments") {

      setColumns([]);

      // BS / PL
      if (activeCat === "BS" || activeCat === "PL") {
        setIsNotes(false);
        setSubMenu(null);
        setColumns([
          {
            label: "Particular",
            field: "particular",
            align: "left",
            editable: false,
          },
          {
            label: "Notes",
            field: "notes",
            align: "left",
            editable: false,
            type: "redirect",
          },
          {
            label: "Current Year",
            field: "currentYear",
            align: "right",
            editable: false,
            type: "number",
          },
          {
            label: "Previous Year",
            field: "previousYear",
            align: "right",
            editable: false,
            type: "number",
          },
          {
            label: "References",
            field: "references",
            align: "left",
            editable: false,
            type: "array",
          },
        ]);
        return;
      }

      // SOCIE / Cashflow
    if (["socie", "cashflow"].includes(activeCat)) {
      setIsNotes(false);
      setSubMenu(null);

        if (rows.length > 0) {
          const catRows = Object.keys(rows[0] || {});
          const sortedRows = [
            ...catRows.filter((c) => {
              const lower = String(c).toLowerCase().trim();
              return (
                !["_id", "linetype", "line type", "line-type", "references", "currentyear", "previousyear", "basecurrentyear", "companies", "isnewrow", "groupingid", "grouping id", "formula"].includes(lower)
              );
            }),
            ...catRows
              .filter((c) =>
                ["currentyear", "previousyear", "basecurrentyear"].includes(
                  c.toLowerCase()
                )
              )
              .sort((a, b) => {
                if (a.toLowerCase().includes("current")) return -1;
                if (b.toLowerCase().includes("current")) return 1;
                return 0;
              }),
          ];

          const tableCols = sortedRows
            .filter(
              (item) =>
                item !== "_id" &&
                item !== "lineType" &&
                item !== "references" &&
                item !== "companies" &&
                !(
                  activeCat === "cashflow" &&
                  item.toLowerCase() === "basecurrentyear"
                )
            )
            .map((item) => {
              const lowerItem = item.toLowerCase();
              const isText =
                lowerItem.includes("particular") ||
                lowerItem.includes("date") ||
                lowerItem.includes("name");
              return {
                label: item,
                field: item,
                align: isText ? "left" : "right",
                editable: false,
                type: isText ? "text" : "number",
              };
            });

          setColumns(tableCols);
        }
        return;
      }

      // Notes categories
      if (
        ["general notes", "BS notes", "PL notes", "disclosure", "checklist"].includes(activeCat)
      ) {
        setIsNotes(true);
        const submenuArray = rows.map((item) => ({
          label: item.particular,
          value: item._id,
          subGroup: item.subgroup,
        }));
        setSubMenu({
          category: activeCat,
          submenu: submenuArray,
        });
        setColumns([]);
        return;
      }

      setIsNotes(false);
      setSubMenu(null);
      setColumns([]);
    }
    setIsNotes(false);
    setSubMenu(null);
    setColumns([]);
  }, [activeCat, rows]);

  useEffect(() => {
    if (consolID) {
      sessionStorage.setItem(`consol_active_cat_${consolID}`, activeCat);
    }
  }, [activeCat, consolID]);

  useEffect(() => {

    if (!isNotes) return;
    if (!subMenu?.submenu?.length) return;

    if (subMenuId) return;
    if (activeCat !== "Adjustments") {

      const first = subMenu.submenu[0];
      setSubMenuId(first.value);
    }
  }, [isNotes, activeCat, subMenu, subMenuId]);

  const handleRowsChange = (updatedRows, subgroupID) => {
    if (activeCat === "cashflow" && !subgroupID) {
      setConsoleData(updatedRows);
      setRows(updatedRows);
      return;
    }

    if (!subgroupID) {
      setRows(updatedRows);
      return;
    }

    setNotesData((prev) => {
      if (!prev) return prev;
      const subgroups = prev.subgroup || prev.subGroup || [];
      return {
        ...prev,
        subgroup: subgroups.map((sg) =>
          sg._id === subgroupID ? { ...sg, table: updatedRows } : sg
        ),
      };
    });

    setRows((prev) =>
      prev.map((group) => {
        if (group._id !== subMenuId) return group;
        return {
          ...group,
          subgroup: (group.subgroup || group.subGroup || []).map((sg) =>
            sg._id === subgroupID ? { ...sg, table: updatedRows } : sg
          ),
        };
      })
    );
  };

  const menuItems = [
    { label: "Balance Sheet", value: "BS" },
    { label: "P&L Statement", value: "PL" },
    { label: "General Notes", value: "general notes" },
    { label: "CashFlow", value: "cashflow" },
    { label: "SOCIE", value: "socie" },
    { label: "Balance Sheet Notes", value: "BS notes" },
    { label: "P&L Statement Notes", value: "PL notes" },
    { label: "Adjustments", value: "Adjustments" },
    { label: "Disclosures", value: "disclosure" },
    // { label: "Disclosures Checklist", value: "checklist" },
  ];

  const adjustmentsMenuItems = [
    { label: "Auto populated entries", value: "Auto populated entries" },
    { label: "Manual adjustments", value: "Manual adjustments" },
    { label: "Inter company elimination", value: "Inter company elimination" }
  ];

  const getPopulateFS = (cat) => {
    const getParams = {
      category: cat,
      consolID: consolID,
    };
    getConsolPrePopulateFSDetailsApiHandler(getParams)
      .then((response) => {
        // RACE CONDITION CHECK
        if (categoryRef.current !== cat) return;

        if (response?.data?.success === true) {
          const catData = response?.data?.data;
          if (cat === "BS" || cat === "PL") {
            setBsPlData(catData);
          }
          if (cat === "cashflow") {
            const data = Array.isArray(catData) ? catData : [];
            setConsoleData(data);
            setRows(data);
          }
          if (cat === "socie") {
            setSocieData(catData);
          }
          if (cat === "BS notes" || cat === "PL notes" || cat === "disclosure") {
            setLoadData(catData);
          }
          if (cat === "general notes" || cat === "checklist") {
            setLoadData(catData);
          }
        }
        else {
          setLoadData([]);
          swal(
            "Error",
            response?.data?.error || "Unable to get FS the data",
            "error"
          );
        }
      })
      .catch((error) => {
        if (categoryRef.current !== cat) return;
        setLoadData([]);
        swal(
          "Error",
          error?.response?.data?.error || "Unable to Populate FS the data",
          "error"
        );
      })
      .finally(() => {
        if (categoryRef.current === cat) {
          setIsLoading(false);
        }
      });
  };

  useEffect(() => {
    categoryRef.current = activeCat;
    setIsLoading(true);
    setLoadData([]);
    setRows([]);
    setBsPlData(null);
    setConsoleData(null);
    setSocieData(null);
    setColumns([]);
    setSubMenu(null);
    setIsNotes(false);
    setNotesData(null);
    setSubGroupId(null);
    setSubMenuId(null);
    if (activeCat !== "Adjustments") {
      getPopulateFS(activeCat);
    } else {
      setIsLoading(false);
    }
  }, [activeCat]);

  const debounceTimer = useRef(null);

  const handleTableEdit = ({ _id, key, value, type = "table", tableId }) => {
    const params = {
      category: activeCat,
      consolID: consolID,
    };

    if (isNotes && type !== "text") {
      params["groupID"] = subMenuId;
      if (activeCat === "checklist") {
        params["subgroupID"] = _id;
      } else {
        params["subgroupID"] = tableId;
        params["rowID"] = _id;
      }
    } else {
      if (
        activeCat === "BS" ||
        activeCat === "PL" ||
        activeCat === "socie" ||
        activeCat === "cashflow" ||
        activeCat === "disclosure"
      ) {
        params["groupID"] = _id;
      }
    }

    const payload = {};

    if (isNotes && type === "text") {
      params["groupID"] = subMenuId;
      params["subgroupID"] = _id;

      payload["dataType"] = "text";
      payload["textRaw"] = key; // html
      payload["textPlain"] = value; // plaintext
    } else {
      if (isNotes) {
        payload["dataType"] = "table";
      }
      payload[key] = value;
    }


    updatePopulateFSApiHandler(params, payload)
      .then((response) => {
        if (response?.data?.success === true) {

          if (isNotes) {
            if (type === "text") {
              setRows((prev) =>
                prev.map((group) => {
                  if (group._id !== subMenuId) return group;
                  return {
                    ...group,
                    subgroup: (group.subgroup || group.subGroup || []).map(
                      (sg) => {
                        if (sg._id !== _id) return sg;
                        return {
                          ...sg,
                          textRaw: payload.textRaw,
                          textPlain: payload.textPlain,
                        };
                      }
                    ),
                  };
                })
              );
            } else {
              setRows((prev) =>
                prev.map((group) => {
                  if (group._id !== subMenuId) return group;
                  return {
                    ...group,
                    subgroup: (group.subgroup || group.subGroup || []).map(
                      (sg) => {
                        if (sg._id !== subgroupId) return sg;
                        return {
                          ...sg,
                          table: (sg.table || []).map((row) =>
                            row._id === _id ? { ...row, [key]: value } : row
                          ),
                        };
                      }
                    ),
                  };
                })
              );
            }
          } else {
            // Non-notes tables (BS, PL, etc.)
            setRows((prev) =>
              prev.map((row) =>
                row._id === _id ? { ...row, [key]: value } : row
              )
            );
          }
        } else {
          swal(
            "Error",
            response?.data?.error || "Unable to update the data",
            "error"
          );
        }
      })
      .catch((error) => {
        swal(
          "Error",
          error?.response?.data?.error || "Unable to save the data",
          "error"
        );
      });
  };

  const handleTableEditDebounced = (args) => {
    clearTimeout(debounceTimer.current);

    debounceTimer.current = setTimeout(() => {

      handleTableEdit(args);
    }, 2000);
  };

  useEffect(() => {
    return () => clearTimeout(debounceTimer.current);
  }, []);

  

  const ShowChecklist = ({ subMenuId }) => {
    if (!subMenu) return null;

    const selNote = subMenu.submenu.find((item) => item.value === subMenuId);
    const rows = selNote?.subGroup || [];

    const checklistColumns = [
      {
        label: "Paragraph reference",
        field: "reference",
        align: "left",
        editable: false,
        type: "popup",
      },
      {
        label: "Disclosure",
        field: "notes",
        align: "left",
        maxWidth: 200,
        editable: false,
        type: "text",
      },
      {
        label: "Yes",
        field: "value",
        optionValue: "Y",
        align: "center",
        editable: false,
        type: "checkbox",
      },
      {
        label: "No",
        field: "value",
        optionValue: "N",
        align: "center",
        editable: false,
        type: "checkbox",
      },
      {
        label: "NA",
        field: "value",
        optionValue: "NA",
        align: "center",
        editable: false,
        type: "checkbox",
      },
      {
        label: "Remarks",
        field: "remark",
        align: "left",
        editable: false,
        type: "text",
      },
    ];

    return (
      <>
        <ConsolFSTable
          columns={checklistColumns}
          rows={rows}
          redirectTo={redirectTo}
          isPrePopulate={true}
          isNotesView={false}
          activeCat={activeCat}
        />
      </>
    );
  };

  const getPopulateFSNotes = async (cat) => {
    try {
      const getParams = {
        category: cat,
        consolID: consolID,
      };

      const response = await getConsolPrePopulateFSDetailsApiHandler(getParams);

      if (response?.data?.success === true) {
        return response.data.data;
      }

      return [];
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  const triggerRedirectSearch = (searchPayload, sourceRows) => {
    const searchArg = String(searchPayload.arg || "").trim().toLowerCase();
    const searchPart = String(searchPayload.particular || "").trim().toLowerCase();

    const normalize = (str) => String(str || "").replace(/[^a-z0-9]/gi, "").toLowerCase();
    const normPart = normalize(searchPart);

    let foundNoteId = null;
    let foundSubGroupId = null;

    // 1. Try to find the Note Header
    const directMatch = sourceRows.find(item => {
      const itemName = String(item.particular || "").trim().toLowerCase();
      const itemNote = String(item.notes || "").trim().toLowerCase();
      const normItemName = normalize(itemName);

      return (
        (normPart && (normItemName === normPart || normItemName.includes(normPart) || normPart.includes(normItemName))) ||
        (searchArg && (itemNote === searchArg || itemNote.includes(searchArg))) ||
        (searchPart && (itemName === searchPart || itemName.includes(searchPart)))
      );
    });

    if (directMatch) {
      foundNoteId = directMatch._id;
      
      // 2. Try to find the specific subgroup/table inside that note
      const sgs = (directMatch.subgroup || directMatch.subGroup || []).filter(
        (sg) => !sg.category || sg.category === searchPayload.targetCat
      );
      const matchingSg = sgs.find(sg => {
        const title = String(sg.tableTitle || sg.particular || "").toLowerCase();
        const normTitle = normalize(title);
        return (
          (normPart && normTitle === normPart) ||
          title.includes(searchPart) || 
          searchPart.includes(title)
        );
      });
      if (matchingSg) foundSubGroupId = matchingSg._id;
    } else {
      // 3. Fallback: Search across all subgroups if Note Header didn't match
      for (const item of sourceRows) {
        const sgs = (item.subgroup || item.subGroup || []).filter(
          (sg) => !sg.category || sg.category === searchPayload.targetCat
        );
        const foundSg = sgs.find(sg => {
          const title = String(sg.tableTitle || sg.particular || "").toLowerCase();
          const normTitle = normalize(title);
          return (normPart && normTitle === normPart) || title.includes(searchPart) || searchPart.includes(title);
        });
        if (foundSg) {
          foundNoteId = item._id;
          foundSubGroupId = foundSg._id;
          break;
        }
      }
    }

    if (foundNoteId) {
      setSubMenuId(foundNoteId);
      setRedirectNote(foundNoteId);
      if (foundSubGroupId) {
        setTargetSubGroupId(foundSubGroupId);
        setSubGroupId(foundSubGroupId);
      }
      setRedirectSearch(null);
    } else if (activeCat === searchPayload.targetCat && sourceRows.length > 0) {
      setRedirectSearch(null);
    }
  };

  const redirectTo = (arg, row) => {
    let targetCat = null;

    if (activeCat === "BS") {
      targetCat = "BS notes";
    } else if (activeCat === "PL") {
      targetCat = "PL notes";
    } else {
      targetCat = activeCat;
    }

    if (targetCat) {
      const searchPayload = {
        arg: arg,
        particular: row?.particular,
        targetCat: targetCat
      };
      setRedirectSearch(searchPayload);
      
      if (targetCat === activeCat) {
        triggerRedirectSearch(searchPayload, rows || []);
      } else {
        setActiveCat(targetCat);
      }
    }
  };

  useEffect(() => {
    if (!redirectSearch || activeCat !== redirectSearch.targetCat || !isNotes || !rows.length) return;
    triggerRedirectSearch(redirectSearch, rows);
  }, [redirectSearch, isNotes, rows, activeCat]);

  useEffect(() => {
    if (targetSubGroupId && isNotes) {
      const timer = setTimeout(() => {
        // Try to scroll to specific row first
        const normalize = (str) => String(str || "").replace(/[^a-z0-9]/gi, "").toLowerCase();
        const rowId = redirectSearch?.particular ? normalize(redirectSearch.particular) : null;
        
        const rowElement = rowId ? document.getElementById(rowId) : null;
        const tableElement = document.getElementById(targetSubGroupId);
        
        const element = rowElement || tableElement;

        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "center" });
          element.classList.add(commoncss.noteSectionHighlight);
          setTimeout(() => element.classList.remove(commoncss.noteSectionHighlight), 2000);
          setTargetSubGroupId(null);
        }
      }, 600);
      return () => clearTimeout(timer);
    }
  }, [targetSubGroupId, isNotes, subMenuId]);

  useEffect(() => {
    setEliminationScreen(0);
    setAdjSubMenu("Auto populated entries");
    if (!isNotes || activeCat === "checklist" || !subMenuId) {
      setNotesData(null);
      return;
    }
    if (activeCat !== "Adjustments") {
      if (!isNotes || activeCat === "checklist" || !subMenuId) {
        setNotesData(null);
        return;
      }
      const selNote = rows.find((item) => item._id === subMenuId) || null;
      setNotesData(selNote);
    }
  }, [isNotes, activeCat, subMenuId, rows]);

  useEffect(() => {
    if (!isNotes || activeCat === "checklist" || !notesData) return;

    if (activeCat !== "Adjustments") {

      if (!isNotes || activeCat === "checklist" || !notesData) return;

      const subGroups = (notesData.subgroup || notesData.subGroup || []).filter(
        (sg) => !sg.category || sg.category === activeCat
      );
      const firstTableSg = subGroups.find(
        (sg) => (sg?.dataType ?? sg?.datatype) === "table"
      );

      setSubGroupId(firstTableSg?._id ?? null);
    }
  }, [isNotes, activeCat, notesData]);

  const showNotesDetails = (noteId) => {
    setSubMenuId(noteId);
  };

  const deletePopulateFS = async (subgroupID) => {
    try {
      const getParams = {
        category: activeCat,
        consolID: consolID,
        groupID: subMenuId,
        subgroupID: subgroupID
      };

      const response = await deletePopulateFSApiHandler(getParams);

      setUpdateTrigger((prev) => prev + 1);
      const delEl = document.getElementById(subgroupID)
      if (delEl) delEl.style.display = "none"
      return [];
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  useEffect(() => {
    if (!isNotes || activeCat === "checklist" || !subMenuId) {
      setNotesData(null);
      return;
    }
    if (activeCat !== "Adjustments") {

      if (!isNotes || activeCat === "checklist" || !subMenuId) {
        setNotesData(null);
        return;
      }

      const selNote = rows.find((item) => item._id === subMenuId) || null;
      setNotesData(selNote);
    }
  }, [updateTrigger]);

  const renderSubGroups = (notesData) => {

    const subGroups = (notesData?.subgroup || notesData?.subGroup || []).filter(
      (sg) => !sg.category || sg.category === activeCat
    );

    if (isLoading) {
      return (
        <div style={{ padding: "20px", textAlign: "center", color: "#66827a" }}>
          Loading content...
        </div>
      );
    }

    return subGroups.map((sg, idx) => {
      const type = sg?.dataType ?? sg?.datatype ?? "";

      //  TABLE 
      if (type === "table") {
        const tableItems = Array.isArray(sg.table) ? sg.table : [];

        if (tableItems.length === 0) {
          return null;
        }

        // const catRows = Object.keys(tableItems[0] || {});
        // const tableCols = catRows
        //   .filter((col) => col !== "_id")
        //   .map((col) => {
          // const rawCols = Object.keys(tableItems[0] || {}).filter(
          //   (col) =>
          //     col !== "_id" &&
          //     col !== "lineType" &&
          //     col.toLowerCase() !== "basecurrentyear" &&
          //     col.toLowerCase() !== "basepreviousyear"
          // );

          // const normalCols = rawCols.filter(
          //   (col) => col !== "references" && col !== "particular"
          // );

          // const orderedCols = [
          //   ...(rawCols.includes("particular") ? ["particular"] : []),
          //   ...normalCols,
          //   ...(rawCols.includes("references") ? ["references"] : []),
          // ];

          // const tableCols = orderedCols.map((col) => {
          //   if (col === "particular") {
          //     return {
          //       label: col,
          //       field: col,
          //       align: "left",
          //       editable: false,
          //       type: "text",
          //       width: 340,
          //       minWidth: 310,
          //       maxWidth: 300,
          //     };
          //   }
          //   if (col === "references") {
          //     return {
          //       label: col,
          //       field: col,
          //       align: "left",
          //       editable: false,
          //       type: "checklistref",
          //       width: 300,
          //       minWidth: 300,
          //       maxWidth: 300,
          //     };
          //   }
          //   const lowerCol = col.toLowerCase();
          //   const isYearCol =
          //     lowerCol.includes("year") ||
          //     lowerCol.includes("amount") ||
          //     lowerCol.includes("value");
          //   return {
          //     label: col,
          //     field: col,
          //     align: isYearCol ? "right" : "left",
          //     editable: false,
          //     type: isYearCol ? "number" : "text",
          //     width: 300,
          //     minWidth: 300,
          //     maxWidth: 300,
          //   };
          // });

          // Check if this is a consol BS notes / PL notes table with companies array
const firstItem = tableItems[0] || {};
const hasCompanies =
  (activeCat === "BS notes" || activeCat === "PL notes" || activeCat === "cashflow") &&
  Array.isArray(firstItem.companies) &&
  firstItem.companies.length > 0;

let tableCols;
let groupedColumns = null;
let flattenedTableItems = tableItems;

if (hasCompanies) {
  // Build grouped columns: Particular | [CompanyName CY|PY] x N | References
  const companyTitles = firstItem.companies.map((c) => c.title);

  groupedColumns = {
    particular: {
      label: "Particular",
      field: "particular",
      align: "left",
      type: "text",
      width: (activeCat === "BS notes" || activeCat === "PL notes") ? 1500 : 750,
      rowSpan: 2,
    },
    companies: companyTitles.map((title) => ({
      title,
      cyField: `${title}_currentYear`,
      pyField: `${title}_previousYear`,
      width: (activeCat === "BS notes" || activeCat === "PL notes") ? 200 : 150,
    })),
  };

  // Flatten rows: spread companies array into flat fields
  flattenedTableItems = tableItems.map((row) => {
    const flatRow = {
      _id: row._id,
      particular: row.particular,
      lineType: row.lineType,
      references: row.references,
    };
    (row.companies || []).forEach((company) => {
      flatRow[`${company.title}_currentYear`] = company.currentYear;
      flatRow[`${company.title}_previousYear`] = company.previousYear;
    });
    return flatRow;
  });
      // Also build flat tableCols for fallback (not used when groupedColumns is passed)
  tableCols = [];
} else {
  // Flat-column tables (no companies array) — build columns from row keys
  const rawCols = Object.keys(firstItem).filter(
    (col) =>
      col !== "_id" &&
      col !== "lineType" &&
      col !== "isBold" &&
      col !== "formulaType" &&
      col !== "companies" &&
      col.toLowerCase() !== "basecurrentyear" &&
      col.toLowerCase() !== "basepreviousyear" &&
      col.toLowerCase() !== "groupingid" &&
      col.toLowerCase() !== "grouping id" &&
      col.toLowerCase() !== "formula"
  );

  const normalCols = rawCols.filter(
    (col) => col !== "references" && col !== "particular" && col !== "groupingid" && col !== "grouping id"
  );

  const orderedCols = [
    ...(rawCols.includes("particular") ? ["particular"] : []),
    ...normalCols,
  ];

  tableCols = orderedCols.map((col) => {
    if (col === "particular") {
      return {
        label: "PARTICULAR",
        field: col,
        align: "left",
        editable: false,
        type: "text",
        width: 750,
        minWidth: 730,
      };
    }
    if (col === "references") {
      return {
        label: "REFERENCES",
        field: col,
        align: "left",
        editable: false,
        type: "checklistref",
        width: 250,
        minWidth: 250,
      };
    }
    // Detect numeric columns: any value in the first non-header row is a number
    const sampleVal = firstItem[col];
    const isNumeric = typeof sampleVal === "number" || (!isNaN(Number(sampleVal)) && sampleVal !== "" && sampleVal !== null && sampleVal !== undefined);
    // Detect column alignment by name
    const colLower = col.toLowerCase();

    // Explicit LEFT override — must come before other checks
    const isForceLeft = colLower.includes("currentnoncurrent");

    // CENTER: date/month/currency/fvlevel/floatingfixed columns
    const isCenter =
      !isForceLeft && (
        colLower.includes("date") ||
        colLower.includes("month") ||
        colLower.includes("currency") ||
        colLower.includes("fvlevel") ||
        colLower.includes("floatingfixed")
      );

    // RIGHT: numeric value / amount / year / measurement category columns
    const isRight =
      !isForceLeft && !isCenter && (
        isNumeric ||
        colLower.includes("amount") ||
        colLower.includes("total") ||
        colLower.includes("current year") ||
        colLower.includes("previous year") ||
        colLower.includes("currentyear") ||
        colLower.includes("previousyear") ||
        colLower.includes("fairvalue") ||
        colLower.includes("level1") ||
        colLower.includes("level2") ||
        colLower.includes("level3") ||
        colLower.includes("measurementcategory") ||
        /\bcy\b/.test(colLower) ||
        /\bpy\b/.test(colLower)
      );

    const align = isForceLeft ? "left" : isCenter ? "center" : isRight ? "right" : "left";
    return {
      label: col,
      field: col,
      align,
      editable: false,
      type: isRight ? "number" : "text",
      width: isRight ? 160 : isCenter ? 200 : 220,
      minWidth: isRight ? 140 : isCenter ? 180 : 200,
    };
  });

  groupedColumns = null;
  flattenedTableItems = tableItems;
}

        return (
  <div 
    key={sg?._id || `table-${idx}`}
    style={{
      paddingBottom: (activeCat === "BS notes" || activeCat === "PL notes") ? "10px" : undefined
    }}
  >
    <ConsolFSTable
      columns={tableCols}
      rows={flattenedTableItems}
      groupedColumns={groupedColumns}
      onRowsChange={(updated) => handleRowsChange(updated, sg._id)}
      redirectTo={redirectTo}
      tableTitle={sg?.tableTitle}
      tableId={sg?._id}
      tableType={sg?.tableType}
      deletePopulateFS={deletePopulateFS}
      isPrePopulate={true}
      isNotesView={false}
      isNotesTable={
        activeCat === "disclosure" || activeCat === "general notes"
      }
      activeCat={activeCat}
      allowDragAndAdd={allowTableRowAdd}
    />
  </div>
        );
      }

      //  TEXT 
      if (type === "text") {
        return (
          <div style={{ marginTop: 20, marginBottom: 24 }} key={sg?._id || `text-${idx}`}>
            <QuillReactEditor
              value={sg?.textRaw ?? ""}
              onChange={(content) => {
                // handleTableEdit({
                //   _id: sg?._id,
                //   key: content.html,
                //   value: content.text,
                //   type: "text",
                // });
              }}
            />
          </div>
        );
      }

      //  FALLBACK 
      return <div key={sg?._id || `empty-${idx}`} />;
    });
  };


  const renderSocie = (socieData) => {
    if (!Array.isArray(socieData) || socieData.length === 0) {
      return (
        <div style={{ padding: "20px", textAlign: "center", color: "#66827a" }}>
          No SOCIE data available
        </div>
      );
    }

    return socieData.map((sg, idx) => {
      const tableItems = (Array.isArray(sg.table) ? sg.table : []).map((row) => {
        const newRow = { ...row };
        Object.keys(newRow).forEach((key) => {
          if (
            key !== "_id" &&
            key !== "particular" &&
            key !== "references" &&
            key !== "lineType" &&
            newRow[key] !== null &&
            newRow[key] !== undefined &&
            !isNaN(newRow[key])
          ) {
            newRow[key] = formatIndianNumber(newRow[key]);
          }
        });
        return newRow;
      });

      if (tableItems.length === 0) {
        return (
          <div key={`socie-empty-${idx}`} className="mb-4">
            <small>No table data for {sg.title}</small>
          </div>
        );
      }

      const firstItem = tableItems[0] || {};

      const rawCols = Object.keys(firstItem).filter(
        (col) =>
          col !== "_id" &&
          col !== "lineType" &&
          col !== "isBold" &&
          col !== "formulaType" &&
          col !== "companies" &&
          col.toLowerCase() !== "basecurrentyear" &&
          col.toLowerCase() !== "basepreviousyear" &&
          col.toLowerCase() !== "groupingid" &&
          col.toLowerCase() !== "grouping id" &&
          col.toLowerCase() !== "formula"
      );

      const normalCols = rawCols.filter(
        (col) => col !== "references" && col !== "particular"
      );

      const orderedCols = [
        ...(rawCols.includes("particular") ? ["particular"] : []),
        ...normalCols,
      ];

      const tableCols = orderedCols.map((col) => {
        if (col === "particular") {
          return {
            label: "PARTICULAR",
            field: col,
            align: "left",
            editable: false,
            type: "text",
            width: 480,
            minWidth: 460,
            sticky: true,
          };
        }
        if (col === "references") {
          return {
            label: "REFERENCES",
            field: col,
            align: "left",
            editable: false,
            type: "checklistref",
            width: 220,
            minWidth: 200,
          };
        }
        // All other columns are numeric for SOCIE
        const sampleVal = firstItem[col];
        const isNumeric = typeof sampleVal === "number" || 
          (sampleVal !== null && sampleVal !== undefined && sampleVal !== "" && 
           !isNaN(Number(String(sampleVal).replace(/,/g, "").replace(/\(/g, "-").replace(/\)/g, ""))));
        return {
          label: col,
          field: col,
          align: isNumeric ? "right" : "left",
          editable: false,
          type: isNumeric ? "number" : "text",
          width: 190,
          minWidth: 170,
        };
      });

      return (
        <React.Fragment key={sg?.title || `socie-${idx}`}>
          <ConsolFSTable
            columns={tableCols}
            rows={tableItems}
            onRowsChange={(updated) => handleRowsChange(updated)}
            redirectTo={redirectTo}
            tableTitle={sg?.title}
            tableId={sg?.title ? `socie-${sg.title.replace(/\s+/g, "-")}` : `socie-${idx}`}
            tableType="socie"
            deletePopulateFS={deletePopulateFS}
            isPrePopulate={true}
            isNotesView={false}
            activeCat={activeCat}
            allowDragAndAdd={allowTableRowAdd}
          />
        </React.Fragment>
      );
    });
  };



  const transformData = (data) => {
    const output = [];

    const walk = (node) => {
      const type = node.lineType === "formula" ? "formula" : (node.level === 1 ? "header" : "row");

      output.push({
        _id: node._id,
        lineType: type,
        particular: node.name,
        notes: node.notes ?? null,
        currentYear: node.currentYear ?? null,
        previousYear: node.previousYear ?? null,
        references: node.references ?? [],
        isBold: node.isBold ?? false,
        level: node.level
      });

      if (node.subgroup && node.subgroup.length) {
        node.subgroup.forEach(walk);
      }
    };

    data.forEach(walk);
    return output;
  };

  const tableData = [
    {
      "_id": "692a3004b4151927e49bb7dd",
      "category": "BS",
      "lineType": "line item",
      "name": "Non-current assets",
      "level": 1,
      "nature": "debit",
      "subgroup": [
        {
          "references": [1, 3],
          "_id": "692a3004b4151927e49bb7de",
          "lineType": "line item",
          "name": "Property, Plant & Equipment",
          "level": 2,
          "subgroup": [
            {
              "references": [],
              "_id": "692a3004b4151927e49bb7df",
              "lineType": "line item",
              "name": "Land - Gross block",
              "level": 3,
              "formula": [],
              "companies": [
                {
                  "title": "Company A",
                  "currentYear": 2000,
                  "previousYear": 1000
                },
                {
                  "title": "Company B",
                  "currentYear": 3000,
                  "previousYear": 2000
                },
                {
                  "title": "Adjustments",
                  "currentYear": 500,
                  "previousYear": 1000
                },
                {
                  "title": "Total",
                  "currentYear": 5500,
                  "previousYear": 4000
                }
              ]
            }
          ],
          "formula": [],
          "notes": 3,
          "companies": [
            {
              "title": "Company A",
              "currentYear": 2000,
              "previousYear": 1000
            },
            {
              "title": "Company B",
              "currentYear": 3000,
              "previousYear": 2000
            },
            {
              "title": "Adjustments",
              "currentYear": 500,
              "previousYear": 1000
            },
            {
              "title": "Total",
              "currentYear": 5500,
              "previousYear": 4000
            }
          ]
        }
      ],
      "formula": []
    }
  ]

  const notesSample = [
    {
      "_id": "6953a4b5d73b643b49e71242",
      "particular": "Property, Plant & Equipment",
      "subgroup": [
        {
          "_id": "6953a4b5d73b643b49e71243",
          "dataType": "table",
          "tableTitle": "Property, Plant & Equipment",
          "table": [
            {
              "references": [],
              "_id": "6953a4b5d73b643b49e71244",
              "particular": "Land - Gross block",
              "companies": [
                {
                  "title": "Company A",
                  "currentYear": 2000,
                  "previousYear": 1000
                },
                {
                  "title": "Company B",
                  "currentYear": 3000,
                  "previousYear": 2000
                },
                {
                  "title": "Adjustments",
                  "currentYear": 500,
                  "previousYear": 1000
                },
                {
                  "title": "Total",
                  "currentYear": 5500,
                  "previousYear": 4000
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "_id": "6953a4b5d73b643b49e71232",
      "particular": "Other Intangible Assets",
      "subgroup": [
        {
          "_id": "6953a4b5d73b643b49e71233",
          "dataType": "table",
          "tableTitle": "Other Intangible Assets",
          "table": [
            {
              "references": [],
              "_id": "6953a4b5d73b643b49e71234",
              "particular": "Brands/trademarks",
              "companies": [
                {
                  "title": "Company A",
                  "currentYear": 2000,
                  "previousYear": 1000
                },
                {
                  "title": "Company B",
                  "currentYear": 3000,
                  "previousYear": 2000
                },
                {
                  "title": "Adjustments",
                  "currentYear": 500,
                  "previousYear": 1000
                },
                {
                  "title": "Total",
                  "currentYear": 5500,
                  "previousYear": 4000
                }
              ]
            }
          ]
        }
      ]
    }
  ]
  return (
    <>
      <div className={`${workSpaceCss.df}`}>
        <div className={`d-flex ${commoncss.pageContent}`} style={{ overflow: "hidden" }}>
          <motion.div
            initial={{ x: -100, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: 100, opacity: 0 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
          >
            <FSSideMenu
              title="Consol FS"
              titleClassName={sidemenucss.customTitle}
              subTitle={selectedConsolName} 
              menuItems={menuItems}
              subMenu={subMenu}
              activeCat={activeCat}
              setActiveCat={setActiveCat}
              setSubMenuId={setSubMenuId}
              showNotesDetails={showNotesDetails}
              redirectNote={redirectNote}
              setRedirectNote={setRedirectNote}
              subMenuId={subMenuId}
              adjustmentsMenuItems={adjustmentsMenuItems}
              adjSubMenu={adjSubMenu}
              setAdjSubMenu={setAdjSubMenu}
              isLoading={isLoading}
            />
          </motion.div>
          <div
            className={bookclosurecss.bookClosureContent}
            style={{ width: "85.5vw", overflow: "hidden" }}
          >
            {activeCat !== "Adjustments" &&
              <div className={`${bookclosurecss.bookClosureHeader} p-0`}>
                <FSTopBar 
                  history={history} 
                  consolID={consolID} 
                  prepopulate={true} 
                  activeCat={activeCat} 
                  workspaceName={workspaceName}
                  consolName={consolName}
                  workspaceID={workspaceID}
                />
              </div>
            }

            <div
              className="hide-scrollbars"
              style={{
                height: "calc(100vh - 75px)",
                overflowY: ["BS", "PL", "socie", "checklist", "BS notes", "PL notes"].includes(activeCat) ? "hidden" : "auto",
                padding:
                activeCat === "general notes"
                  ? "2px 10px 0px 20px"
                  : ["cashflow", "socie", "BS notes", "PL notes"].includes(activeCat)
                  ? "5px 10px 0px 20px"
                  : ["disclosure", "checklist"].includes(activeCat)
                  ? "5px 25px 0px 25px"
                  : "5px 10px 0px 20px",
              }}
            >
              {/* <BSPLTable tableData={tableData} /> */}
              {!isNotes && activeCat !== "checklist" && (activeCat === "BS" || activeCat === "PL") && (
                <div className="bs-pl-notes-wrapper">
                  <BSPLTable tableData={bsPlData} redirectTo={redirectTo} isPrePopulate={true} />
                </div>
              )}
 
              {!isNotes && activeCat !== "checklist" && activeCat === "cashflow" && (
                <div
                  className="cashflow-scroll-wrapper"
                >
                  <ConsoleTable
                    tableData={consoleData}
                    isPrePopulate={true}
                    type="cashflow"
                    id="consol-prepopulate-cashflow"
                    prePopulateCashflowUI={true}
                    onRowsChange={(updated) => handleRowsChange(updated)}
                  />
                </div>
              )}

              {!isNotes && activeCat !== "checklist" && socieData && (activeCat === "socie") && (
                <div
                  className="socie-scroll-wrapper"
                  style={{
                    height: "calc(100vh - 150px)",
                    overflowY: "auto",
                    overflowX: "auto",
                    paddingTop: 0,
                    paddingBottom: 0,
                  }}
                >
                  {renderSocie(socieData)}
                </div>
              )}


              {isNotes && notesData && activeCat !== "checklist" && activeCat !== "Adjustments" && (
                <div>
                  {renderSubGroups(notesData)}
                </div>
              )}

              {isNotes && subMenuId && activeCat === "checklist" && activeCat !== "Adjustments" && (
                <ShowChecklist subMenuId={subMenuId} />
              )}
              {activeCat === "Adjustments" && adjSubMenu === "Auto populated entries" && (
                <AdjAutoPopulatedEntries
                  history={history}
                  consolID={consolID} />
              )}
              {activeCat === "Adjustments" && adjSubMenu === "Manual adjustments" && (
                <ManualAdjustments
                  history={history}
                  consolID={consolID} />
              )}
              {showBottomAddControls && (
                <ConsolFSBottomAddSection
                  bottomBlocks={bottomBlocks}
                  onDragEndItems={onDragEndItems}
                  updateEditorContent={updateEditorContent}
                  removeItem={removeItem}
                  forceOpenTableId={forceOpenTableId}
                  setForceOpenTableId={setForceOpenTableId}
                  updateTableItem={updateTableItem}
                  handleAddParagraph={handleAddParagraph}
                  handleAddTable={handleAddTable}
                  isAddingTable={isAddingTable}
                  setIsAddingTable={setIsAddingTable}
                  onNewTableBlock={onNewTableBlock}
                />
              )}

              {activeCat === "Adjustments" && adjSubMenu === "Inter company elimination" && (
                <>
                  {eliminationScreens[eliminationScreen] === "entries" && (
                    <InterCompanyEliminationsEntries
                      setEliminationScreen={setEliminationScreen}
                      history={history}
                      consolID={consolID}
                    />
                  )}

                  {eliminationScreens[eliminationScreen] === "workings" && (
                    <ICEWorkings setEliminationScreen={setEliminationScreen}
                      consolID={consolID}
                    />
                  )}

                  {eliminationScreens[eliminationScreen] === "performreconciliation" && (
                    <PerformReconciliation setEliminationScreen={setEliminationScreen}
                      consolID={consolID}
                      setSelectedReconciliationRow={setSelectedReconciliationRow}
                    />
                  )}

                  {eliminationScreens[eliminationScreen] === "viewreconciliation" && (
                    <ViewReconciliation setEliminationScreen={setEliminationScreen}
                      consolID={consolID}
                      configIndex={selectedReconciliationRow?.configIndex}
                      parentCompanyID={selectedReconciliationRow?.parentCompanyID}
                      subsidiaryCompanyID={selectedReconciliationRow?.subsidiaryCompanyID}
                    />
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConsolPrePopulateFS;

